<div class="container-fluid">

  <h4 id="upper">Fiche evaluation du Se</h4>
  <div class="d-flex justify-content-end">
    <!-- <div class="me-3">
        <label class="d-inline-flex align-items-center">
          Début:
          <input disabled type="date" class="form-control ms-2" [(ngModel)]="dateDebut" name="dateDebut">
        </label>
      </div> -->

    <!-- <div class="me-3">
        <label class="d-inline-flex align-items-center">
          Fin:
          <input type="date" class="form-control ms-2" [(ngModel)]="dateFin" name="dateFin">
        </label>
      </div> -->
    <!-- <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <label class="d-inline-flex align-items-center">
          Direction:
          <select style="width: 200px;" type="text" name="searchTerm" class="form-select ms-2"
            aria-controls="tickets-table" [(ngModel)]="directionId" (change)="getStatistique()">
            <option disabled value="Séléctionner une direction"></option>
            <option *ngFor="let item of directionItems" [value]="item.reference"> {{ item?.libelle}}</option>
          </select>
        </label>
      </div>
    </div> -->

    <!-- Bouton Rechercher -->
    <!-- <div class="me-3">
      <div id="tickets-table_filter" class="dataTables_filter">
        <input (click)="getStatistique()" type="button" value="Rechercher" class="btn btn-primary">
      </div>
    </div> -->
    <!-- Bouton Exporter -->
   <!-- <div class="dropdown d-inline-block" ngbDropdown>
      <button type="button" ngbDropdownToggle class="btn btn-primary dropdown-toggle" id="dropdownMenuButton"
        aria-haspopup="true" aria-expanded="false">
        Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format PDF</a>
        <a  class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format Excel</a>
      </div>
    </div> -->

  </div>
  <!-- <div class="row"> -->
<!--     <div class="col-lg-12">
 -->      <!-- <div class="card"> -->
        <!-- <div *ngFor="let programme of paginatedProjets" class="card mb-2"> -->
          <!-- <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
            (click)="programme.expanded = !programme.expanded" style="cursor: pointer;">
            <div style="font-size: 15px;">
              Programme : {{ programme.sigle ?? 'N/A' }} - {{ programme.libelle || 'Libellé manquant' }}
            </div>
            <div> -->
              <!-- <small style="font-size: 15px;">Coût : {{ programme.cout |formatMoney:null ?? 0 }} FCFA | Poids : {{ programme.poids ?? 0 }}</small> -->
              <!-- <span [innerHTML]="programme.expanded ? '&#9650;' : '&#9660;'"></span> -->
            <!-- </div>
          </div> -->

          <!-- <div *ngIf="programme.expanded" class="card-body">
            <div *ngFor="let action of programme.actions || []" class="card mb-2">
              <div class="card-header bg-secondary text-white d-flex justify-content-between align-items-center"
                (click)="action.expanded = !action.expanded" style="cursor: pointer;">
                <div style="font-size: 15px;">Action : {{ action.code ?? 'N/A' }} - {{ action.libelle || 'Libellé manquant' }}</div>
                <div>
                  <small style="font-size: 15px;">Montant : {{ action.montant|formatMoney:null  ?? 0 }} FCFA | Durée : {{ action.duree ?? 0 }} mois | Poids : {{
                    action.poids ?? 0 }}</small>
                  <span [innerHTML]="action.expanded ? '&#9650;' : '&#9660;'"></span>
                </div>
              </div>
              <div *ngIf="action.expanded" class="card-body">
                <div *ngFor="let ptAction of action.pt_actions || []" class="card mb-2">
                  <div class="card-header bg-info text-white d-flex justify-content-between align-items-center"
                    (click)="ptAction.expanded = !ptAction.expanded" style="cursor: pointer;">
                    <div style="font-size: 15px;">PT Action : {{ ptAction.code ?? 'N/A' }} - {{ ptAction.libelle || 'Libellé manquant' }}</div>
                    <div>
                      <small style="font-size: 15px;">Année : {{ ptAction.annee ?? '-' }} | Montant Total : {{ ptAction.montant_total |formatMoney:null  ?? 0 }}
                        FCFA | Poids : {{ ptAction.poids ?? 0 }}</small>
                      <span  [innerHTML]="ptAction.expanded ? '&#9650;' : '&#9660;'"></span>
                    </div>
                  </div>
                  <div *ngIf="ptAction.expanded" class="card-body">
                    <div *ngFor="let activite of ptAction.pta_activites || []" class="card mb-2">
                      <div class="card-header bg-success text-white d-flex justify-content-between align-items-center"
                        (click)="activite.expanded = !activite.expanded" style="cursor: pointer;">
                        <div style="font-size: 15px;">Activité : {{ activite.code_activite ?? 'N/A' }} - {{ activite.activite || 'Libellé manquant' }}
                        </div>
                        <div>
                          <small style="font-size: 15px;">Montant total  : {{ activite.total ?? 0 }} FCFA | TEP prévu/réalisé : {{ activite.tep_prevu ??
                            0 }} / {{ activite.tep_realise ?? 0 }}</small>
                          <span [innerHTML]="activite.expanded ? '&#9650;' : '&#9660;'"></span>
                        </div>
                      </div>
                      <div *ngIf="activite.expanded" class="card-body">
                        <button class="btn btn-sm btn-outline-primary" (click)="openTachesModal(activite)">Voir
                          tâches</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <!-- Fin programme -->
    <!-- <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets"
                                [rows]="rowsProjets" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                            </p-paginator>
      </div>
    </div>
  </div> -->


<!-- </div> -->
<!-- Modal Tâches -->
<ng-template #detailModal let-modal>

  <div>
    <div class="">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="fs-4">Tâches de l'activité : <strong>{{ selectedActivite?.activite }}</strong></h6>
          <button (click)="close()"  type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <table class="table table-sm table-bordered">
            <thead>
              <tr>
                <th>Code</th>
                <th>Libellé</th>
                <th>Date début</th>
                <th>Date fin</th>
                <th>Poids</th>
                <th>Réalisée</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tache of selectedActivite?.pta_taches">
                <td>{{ tache.code }}</td>
                <td>{{ tache.libelle }}</td>
                <td>{{ tache.date_debut | date: 'dd/MM/yyyy' }}</td>
                <td>{{ tache.date_fin | date: 'dd/MM/yyyy' }}</td>
                <td>{{ tache.poids }}</td>
            <td>
        <span [ngClass]="{'bg-success text-white px-2 rounded': tache.realisee,  'bg-danger text-white px-2 rounded': !tache.realisee }"
        > {{ tache.realisee ? 'Réalisée' : 'Non réalisée' }}
        </span>
      </td>

              </tr>
              <tr *ngIf="!selectedActivite?.pta_taches?.length">
                <td colspan="6" class="text-center">Aucune tâche définie</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button (click)="close()" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>